import { motion } from "framer-motion";

// Agrega aquí los logos: copia el archivo en /public/clientes/ y añade { nombre, logo: "/clientes/archivo.png" }
export const CLIENTES = [
    { nombre: "FISOL — Filtros y Soluciones SAS", logo: "/clientes/fisol.png" },
    { nombre: "MERCOL SAS", logo: "/clientes/mercol.png" },
    { nombre: "Cuy Fashion — Moda Colombiana", logo: "/clientes/cuy-fashion.png" },
    { nombre: "Dra. Mariana Aguirre Cano — Odontología", logo: "/clientes/mc-odontologia.png", dark: true },
    { nombre: "Pacífico Films", logo: "/clientes/pacifico.png" },
    { nombre: "WG", logo: "/clientes/wg.png" },
    { nombre: "Milveinte", logo: "/clientes/milveinte.png" },
    { nombre: "Ferretería La 50", logo: "/clientes/la50.png" },
];

function Logo({ nombre, logo, dark, index }) {
    return (
        <div
            className={`mx-5 flex h-28 w-52 shrink-0 items-center justify-center border px-6 py-4 shadow-[0_8px_24px_-12px_rgba(10,17,40,0.35)] transition-transform duration-500 hover:-translate-y-1 md:mx-7 md:h-32 md:w-60 ${
                dark ? "border-black bg-black" : "border-navy/15 bg-white"
            }`}
            data-testid={`cliente-logo-${index}`}
        >
            {logo ? (
                <img
                    src={logo}
                    alt={nombre}
                    title={nombre}
                    loading="lazy"
                    className="max-h-full max-w-full object-contain"
                />
            ) : (
                <span className="border border-navy/15 px-6 py-3 font-display text-lg italic text-navy/40">{nombre}</span>
            )}
        </div>
    );
}

export default function Clientes() {
    const row = [...CLIENTES, ...CLIENTES];
    return (
        <section id="clientes" className="relative overflow-hidden border-t border-navy/10 bg-[#E4E8F0] py-20 text-navy md:py-28" data-testid="clientes-section">
            <div className="mx-auto mb-12 max-w-[1440px] px-6 md:mb-16 md:px-12">
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="mb-6 text-[11px] uppercase tracking-[0.3em] text-gold-dim"
                    data-testid="clientes-overline"
                >
                    Nuestros clientes
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                    className="max-w-2xl font-display text-3xl font-medium leading-[1.05] tracking-tighter sm:text-4xl lg:text-5xl"
                    data-testid="clientes-heading"
                >
                    Empresas que confían en nosotros en toda Colombia.
                </motion.h2>
            </div>

            <div className="relative" data-testid="clientes-marquee">
                <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#E4E8F0] to-transparent md:w-48" />
                <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#E4E8F0] to-transparent md:w-48" />
                <div className="animate-marquee-logos flex w-max items-center py-3">
                    {row.map((c, i) => (
                        <Logo key={i} index={i} {...c} />
                    ))}
                </div>
            </div>
        </section>
    );
}
